"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CHARGE_TYPE;
(function (CHARGE_TYPE) {
    CHARGE_TYPE["BANK_DEBIT"] = "bank_debit";
    CHARGE_TYPE["BANK_DEBIT_CUSTOMER_NOT_PRESENT"] = "bank_debit_cnp";
})(CHARGE_TYPE = exports.CHARGE_TYPE || (exports.CHARGE_TYPE = {}));
var CHARGE_STATUS;
(function (CHARGE_STATUS) {
    CHARGE_STATUS["CREATED"] = "created";
    CHARGE_STATUS["AUTHORIZED"] = "authorized";
    CHARGE_STATUS["CAPTURED"] = "captured";
    CHARGE_STATUS["CANCELED"] = "canceled";
    CHARGE_STATUS["ATTEMPTING_COLLECTION"] = "attempting_collection";
    CHARGE_STATUS["CAPTURE_FAILED"] = "capture_failed";
    CHARGE_STATUS["DISPUTED"] = "disputed";
    CHARGE_STATUS["REFUND_PENDING"] = "refund_pending";
    CHARGE_STATUS["REFUNDED"] = "refunded";
})(CHARGE_STATUS = exports.CHARGE_STATUS || (exports.CHARGE_STATUS = {}));
var PROMOTION_TYPE;
(function (PROMOTION_TYPE) {
    PROMOTION_TYPE["CREDIT"] = "credit";
})(PROMOTION_TYPE = exports.PROMOTION_TYPE || (exports.PROMOTION_TYPE = {}));
var BENEFIT_TYPE;
(function (BENEFIT_TYPE) {
    BENEFIT_TYPE["FIXED"] = "fixed";
})(BENEFIT_TYPE = exports.BENEFIT_TYPE || (exports.BENEFIT_TYPE = {}));
//# sourceMappingURL=types.js.map